import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface WithdrawalsTopBarActionsProps {
  onGeneratePaymentFiles: () => void;
  onViewPaymentFiles: () => void;
  isGenerating?: boolean;
}

export const WithdrawalsTopBarActions = ({
  onGeneratePaymentFiles,
  onViewPaymentFiles,
  isGenerating = false,
}: WithdrawalsTopBarActionsProps) => {
  const { t } = useTranslation('withdrawalsModule');

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <Button
        variant="outline"
        className="border-card-border bg-card-bg"
        onClick={onViewPaymentFiles}
        data-testid="header-action-view-payment-files"
      >
        <span className="hidden sm:inline">{t('buttons.viewPaymentFiles')}</span>
        <span className="sm:hidden">{t('buttons.viewPaymentFilesShort')}</span>
      </Button>
      <Button
        variant="primary"
        onClick={onGeneratePaymentFiles}
        disabled={isGenerating}
        data-testid="header-action-generate-payment-files"
      >
        <span className="hidden sm:inline">
          {isGenerating ? t('buttons.generatingPaymentFiles') : t('buttons.generatePaymentFiles')}
        </span>
        <span className="sm:hidden">{isGenerating ? t('buttons.generatingShort') : t('buttons.generateShort')}</span>
      </Button>
    </div>
  );
};
